





































































































































import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import Industries from '@/common/components/Industries.vue'

import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'

export default Vue.extend({
  components: {
    BaseImage,
    Industries
  },
  computed: {
    placeholder() {
      return SVG_PLACEHOLDER_IMAGES.MAGAZINE_CARD
    },
    placeholderSquare() {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  }
})
